/**
 * @description DimensionSelect 维度筛选器常量配置
 */

import type { TDimension } from '../../types';
import type { IDimensionOption } from './types';

/**
 * SensorTower 维度选项
 */
export const SENSORTOWER_DIMENSION_OPTIONS: IDimensionOption[] = [
  { value: 'mainGenre', i18nKey: 'dbi_casual_dimension_main_genre' },
  { value: 'subGenre', i18nKey: 'dbi_casual_dimension_sub_genre' },
];

/**
 * AppMagic 维度选项
 */
export const APPMAGIC_DIMENSION_OPTIONS: IDimensionOption[] = [
  { value: 'superGenre', i18nKey: 'dbi_casual_dimension_super_genre' },
  { value: 'majorCategory', i18nKey: 'dbi_casual_dimension_level1_genre' },
  { value: 'midCategory', i18nKey: 'dbi_casual_dimension_level2_genre' },
  { value: 'subCategory', i18nKey: 'dbi_casual_dimension_level3_genre' },
];

/**
 * 品类数据源与维度选项的映射
 */
export const DIMENSION_OPTIONS_MAP: Record<IGenreSource, IDimensionOption[]> = {
  iegg: SENSORTOWER_DIMENSION_OPTIONS,
  sensortower: SENSORTOWER_DIMENSION_OPTIONS,
  annie: SENSORTOWER_DIMENSION_OPTIONS,
  appmagic: APPMAGIC_DIMENSION_OPTIONS,
};

/**
 * 默认维度值映射
 */
export const DEFAULT_DIMENSION_MAP: Record<IGenreSource, TDimension> = {
  iegg: 'subGenre',
  sensortower: 'subGenre',
  annie: 'subGenre',
  appmagic: 'majorCategory',
};
